import React from "react";
import {
  Document,
  Page,
  Text,
  View,
  StyleSheet,
  PDFViewer,
  Image,
} from "@react-pdf/renderer";
import image from "../../../assets/img/marifer.png";

const styles = StyleSheet.create({
  image: {
    position: "relative",
    objectFit: "cover",
    zIndex: -999,
    width: "120px",
    height: "120px",
    paddingLeft: 0,
    opacity: 0.9,
  },
  header: {
    color: "#ff0080",
    textTransform: "uppercase",
    marginTop: 15,
    paddingLeft: 30,
    fontSize: "16pt",
    fontWeight: "extrabold",
  },
  page: {
    fontSize: "14pt",
    padding: 10,
  },
  mainSection: {
    flexDirection: "row",
    textAlign: "center",
    height: "3.5cm",
  },
  viewer: {
    width: "100%",
    height: window.innerHeight,
  },
});

const now = new Date();
const formatDate = `${now.getFullYear()}-${String(now.getMonth() + 1).padStart(2, "0")}-${String(now.getDate()).padStart(2, "0")} ${String(now.getHours()).padStart(2, "0")}:${String(now.getMinutes()).padStart(2, "0")}`;

const ReportByClothPdf = ({ rolls, clothName }) => {
  const totalRolls = rolls.length;
  const totalKg = Math.round(rolls.reduce((sum, r) => sum + (parseFloat(r.totalKg) || 0), 0) * 100) / 100;
  const totalMeters = Math.round(rolls.reduce((sum, r) => sum + (parseFloat(r.meters) || 0), 0) * 100) / 100;

  return (
    <PDFViewer style={styles.viewer}>
      <Document>
        <Page size="LETTER" style={styles.page}>
          {/* Header */}
          <View style={styles.mainSection}>
            <Image style={styles.image} src={image} />
            <View>
              <Text style={styles.header}>
                {`Reporte de Rollos`}
              </Text>
              <Text style={{ fontSize: 12, paddingLeft: 30, marginTop: 5, color: "#333" }}>
                {`Tela: ${clothName}`}
              </Text>
              <Text style={{ fontSize: 9, paddingLeft: 30, marginTop: 3, color: "#666" }}>
                {formatDate}
              </Text>
            </View>
          </View>

          {/* Resumen */}
          <View style={{ flexDirection: "row", marginTop: 5, marginBottom: 8, fontSize: 10 }}>
            <View style={{ border: 1, padding: 4, width: 100, textAlign: "center", backgroundColor: "#f9c6cf" }}>
              <Text>{"Total Rollos"}</Text>
              <Text style={{ fontSize: 14, fontWeight: "bold", marginTop: 2 }}>{totalRolls}</Text>
            </View>
            <View style={{ border: 1, padding: 4, width: 100, textAlign: "center", backgroundColor: "#f9c6cf" }}>
              <Text>{"Total Kg"}</Text>
              <Text style={{ fontSize: 14, fontWeight: "bold", marginTop: 2 }}>{totalKg}</Text>
            </View>
            <View style={{ border: 1, padding: 4, width: 100, textAlign: "center", backgroundColor: "#f9c6cf" }}>
              <Text>{"Total Metros"}</Text>
              <Text style={{ fontSize: 14, fontWeight: "bold", marginTop: 2 }}>{totalMeters}</Text>
            </View>
          </View>

          {/* Tabla */}
          <View style={{ border: 1 }}>
            {/* Encabezado */}
            <View style={{
              flexDirection: "row",
              textAlign: "center",
              fontSize: "10pt",
              backgroundColor: "#f9c6cf",
              height: 20,
            }}>
              <View style={{ width: "5%", border: 1, padding: "3px" }}>
                <Text>{"No."}</Text>
              </View>
              <View style={{ width: "20%", border: 1, padding: "3px" }}>
                <Text>{"Código"}</Text>
              </View>
              <View style={{ width: "20%", border: 1, padding: "3px" }}>
                <Text>{"Color"}</Text>
              </View>
              <View style={{ width: "15%", border: 1, padding: "3px" }}>
                <Text>{"Kg"}</Text>
              </View>
              <View style={{ width: "15%", border: 1, padding: "3px" }}>
                <Text>{"Metros"}</Text>
              </View>
              <View style={{ width: "25%", border: 1, padding: "3px" }}>
                <Text>{"Entrada"}</Text>
              </View>
            </View>

            {/* Filas */}
            {rolls.length === 0 ? (
              <View style={{ flexDirection: "row", textAlign: "center", fontSize: "10pt" }}>
                <View style={{ width: "100%", border: 1, padding: "3px" }}>
                  <Text>{"No hay rollos para esta tela."}</Text>
                </View>
              </View>
            ) : (
              rolls.map((r, idx) => (
                <View
                  key={idx}
                  style={{
                    flexDirection: "row",
                    textAlign: "center",
                    fontSize: "8pt",
                    color: "#000111",
                  }}
                >
                  <View style={{ width: "5%", border: 1, padding: "3px" }}>
                    <Text>{idx + 1}</Text>
                  </View>
                  <View style={{ width: "20%", border: 1, padding: "3px" }}>
                    <Text>{r.code}</Text>
                  </View>
                  <View style={{ width: "20%", border: 1, padding: "3px" }}>
                    <Text>{r.color || "-"}</Text>
                  </View>
                  <View style={{ width: "15%", border: 1, padding: "3px" }}>
                    <Text>{r.totalKg}</Text>
                  </View>
                  <View style={{ width: "15%", border: 1, padding: "3px" }}>
                    <Text>{r.meters}</Text>
                  </View>
                  <View style={{ width: "25%", border: 1, padding: "3px" }}>
                    <Text>{r.inputs?.date || "-"}</Text>
                  </View>
                </View>
              ))
            )}
          </View>
        </Page>
      </Document>
    </PDFViewer>
  );
};

export default ReportByClothPdf;
